import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import PredictiveSearch from './PredictiveSearch';

export default class SearchFlyout {
  constructor(el, data) {
    this.el = el;
    this.data = data;
    this.siteOverlay = document.querySelector('[data-site-overlay]');
    this.header = document.querySelector('[data-site-header]');
    this.headerContainer = document.querySelector('[data-site-header-container]');
    this.input = this.el.querySelector('[data-search-input]');
    this.closeBtn = this.el.querySelector('[data-search-flyout-close]');

    this.animation = transition({ el: this.el, state: 'closed' });
    this.siteOverlayAnimation = transition({ el: this.siteOverlay });

    this.events = new EventHandler();
    this.isOpen = false;

    if (this.data.enable_predictive_search) {
      this.predictiveSearch = new PredictiveSearch(this.el);
    }

    this.events.register(window, 'keyup', e => this._onKeyUp(e));
    this.events.register(this.closeBtn, 'click', e => this.close(e));
    // We want the flydown to close not only when you click outside but also when you tab outside.
    // `focusout` doesn't work as expected so we'll use `focusin`.
    this.events.register(document.documentElement, 'focusin', () => this.close());
    this.events.register(this.el, 'focusin', e => e.stopPropagation());
    this.events.register(document.body, 'click', e => {
      if (e.target === this.searchCloseButton || !e.target.closest('[data-search-flyout]')) {
        this.close();
      }
    });
  }

  _onKeyUp(e) {
    if (e.code === 'Escape') {
      this.input.value = '';
      this.close();
    }
  }

  open() {
    if (this.isOpen) return;

    this.animation.animateTo('open')
      .then(() => {
        document.body.classList.add('scroll-locked');
        this.siteOverlayAnimation.animateTo('open');
        this.input.focus();
        // Set the cursor at the end of the input field for better UX,
        // otherwise it may be at the beginning of the input field when the input gets focus.
        const strLen = this.input.value.length;
        this.input.setSelectionRange(strLen, strLen);
        this.isOpen = true;
      });
  }

  close() {
    if (!this.isOpen) return;

    // this.predictiveSearch.close() can return false, in which case,
    // use a Promise so `.then()` calls can be made below.
    const closeFn = this.predictiveSearch?.close() || new Promise(resolve => resolve());

    closeFn
      .then(() => this.animation.animateTo('closed'))
      .then(() => {
        document.body.classList.remove('scroll-locked');
        this.siteOverlayAnimation.animateTo('close');
        this.isOpen = false;
      });
  }
}
